// Other names people search an occasion by, where the app's own title uses
// different words: the official calendar's name, or the everyday one. Search
// reads them as part of the title. Nothing else shows them.
//
// Keyed by where the occasion sits: its list (j, g or h, as in
// services/occasions.ts), its month and its day. So a title can be reworded
// without losing its other names. The search tests check that every key still
// names an occasion in the lists.
export const OCCASION_ALIASES: Record<string, string[]> = {
    // 28 صفر. The official calendar calls it رحلت حضرت رسول اکرم, and رحلت is
    // the word people search it by.
    'h:2:28': ['رحلت پیامبر', 'رحلت حضرت رسول اکرم'],
}
